webpackJsonp([202660965941462],{

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	__webpack_require__(592);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectItem = function ProjectItem(_ref) {
	  var to = _ref.to,
	      title = _ref.title,
	      description = _ref.description,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'projects__item' },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: to },
	      _react2.default.createElement(
	        'h1',
	        null,
	        title
	      ),
	      description && _react2.default.createElement(
	        'p',
	        null,
	        description
	      )
	    ),
	    children
	  );
	};
	
	var Projects = function (_React$Component) {
	  _inherits(Projects, _React$Component);
	
	  function Projects() {
	    _classCallCheck(this, Projects);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Projects.prototype.render = function render() {
	    var projects = this.props.data.allMarkdownRemark.edges;
	    var firstExperiment = projects.filter(function (p) {
	      return p.node.fields.slug.indexOf('viz') !== -1;
	    })[0];
	    return _react2.default.createElement(
	      'div',
	      { className: 'page projects container' },
	      firstExperiment && _react2.default.createElement(
	        ProjectItem,
	        { to: '/projects/viz',
	          title: 'Viz',
	          description: 'Ongoing practice and exploration with creative coding tools.' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'latest: ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: firstExperiment.node.fields.slug },
	              firstExperiment.node.frontmatter.title
	            )
	          )
	        )
	      ),
	      projects.filter(function (p) {
	        return p.node.fields.slug.indexOf('viz') === -1;
	      }).map(function (p, i) {
	        return _react2.default.createElement(ProjectItem, { key: i,
	          to: p.node.fields.slug,
	          title: p.node.frontmatter.title,
	          description: p.node.frontmatter.description
	        });
	      })
	    );
	  };
	
	  return Projects;
	}(_react2.default.Component);
	
	exports.default = Projects;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-index-js-78077d2b7f45a711bdb7.js